import * as React from "react";
import { forwardRef } from "react";
const SvgOntapDefault = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 65, height: 65, viewBox: "0 0 65 65", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { transform: "translate(0.5 0.5)" }, /* @__PURE__ */ React.createElement("circle", { cx: 32, cy: 32, r: 32, fill: "#fff", stroke: "#e8e8e8" }), /* @__PURE__ */ React.createElement("path", { fill: "#0167c5", fillRule: "evenodd", d: "M18 40.385h9.335V28.754h5.329v11.631H42V21H18z", transform: "translate(2 1)" })));
const ForwardRef = forwardRef(SvgOntapDefault);
export { ForwardRef as ReactComponent };
